import React from "react";
import { NativeBridge, NavigationScreenLinkTypes, NavigationTypes } from "@swiggy-private/native-bridge";
import { QrCodeActions } from "@swiggy-private/portal-dineout-context";
import type { IQrCodeAction, IReducerResponse } from "@swiggy-private/portal-dineout-context";
import type { NextRouter } from "next/router";
import { ROUTES } from "../constants";
import { TabType } from "../types/cart";

let bridgeSdk: NativeBridge | null = null;

export const initBridgeSdk = ({
    sdk,
    dispatch,
    router,
    override = false,
}: {
    state?: IReducerResponse;
    dispatch?: React.Dispatch<IQrCodeAction>;
    router?: NextRouter | null;
    sdk?: NativeBridge;
    override?: boolean;
}): NativeBridge => {
    if (bridgeSdk && !sdk) {
        return bridgeSdk;
    }

    bridgeSdk = sdk || new NativeBridge(null);
    if (override) {
        const navScreen = bridgeSdk.navigateToScreen;
        bridgeSdk.navigateToScreen = (payload) => {
            if (payload.type === NavigationTypes.SCREEN) {
                if (payload.link === NavigationScreenLinkTypes.TRACK) {
                    dispatch?.({
                        type: QrCodeActions.PLACE_ORDER_UPDATE,
                        payload: {},
                    });
                    router?.push(`${ROUTES.CART_ORDERS}?tab=${TabType.ORDERS}`);
                }
                return Promise.resolve(undefined);
            }
            return navScreen(payload);
        };
    }
    return bridgeSdk;
};

/**
 * get instance for bridge sdk via getBridgeSdk
 * @returns instance for bridge SDK
 */
export const getBridgeSdk = (): NativeBridge => bridgeSdk || initBridgeSdk({});
